import {ICommunication} from 'Common/store/utils/communication';

export default function makeCommunicationSelector<
  S,
  T extends {communications: Record<keyof T['communications'], ICommunication<any>>}
>(selectState: (state: S) => T) {
  return <P = undefined>(state: S, comm: keyof T['communications']): ICommunication<P> =>
    selectState(state).communications[comm];
}
